import type { JobStats } from '../../types/jobs';

interface JobStatsBarProps {
  stats: JobStats | null;
}

function formatCost(value: number): string {
  return `$${value.toFixed(2)}`;
}

function rateColorClass(rate: number): string {
  if (rate >= 90) return 'text-success';
  if (rate >= 70) return 'text-warning';
  return 'text-error';
}

export default function JobStatsBar({ stats }: JobStatsBarProps) {
  if (!stats) return null;

  return (
    <div className="bg-bg-secondary border border-border-subtle rounded-lg p-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4 md:gap-8">
      <div className="flex flex-col">
        <span className="text-xl font-bold text-text-primary">{stats.totalJobs}</span>
        <span className="text-xs text-text-muted">Total Jobs</span>
      </div>

      <div className="flex flex-col">
        <span className="text-xl font-bold text-text-primary flex items-center gap-2">
          {stats.runningNow}
          {stats.runningNow > 0 ? (
            <span className="h-2 w-2 rounded-full bg-accent-purple animate-pulse-dot" />
          ) : null}
        </span>
        <span className="text-xs text-text-muted">Running Now</span>
      </div>

      <div className="flex flex-col">
        <span className="text-xl font-bold text-text-primary">{stats.todayRuns}</span>
        <span className="text-xs text-text-muted">Today's Completed</span>
      </div>

      <div className="flex flex-col">
        <span className={`text-xl font-bold ${rateColorClass(stats.todaySuccessRate)}`}>
          {stats.todaySuccessRate.toFixed(0)}%
        </span>
        <span className="text-xs text-text-muted">Success Rate</span>
      </div>

      <div className="flex flex-col">
        <span className="text-xl font-bold text-text-primary">{formatCost(stats.todayCost)}</span>
        <span className="text-xs text-text-muted">Today's Cost</span>
      </div>
    </div>
  );
}
